export const SHOULD_HAVE_TWO_DECIMALS_REGEX = /^[0-9]+(\.\d{1,2})?$/;
export const SHOULD_HAVE_THREE_DECIMALS_REGEX = /^[0-9]+(\.\d{1,3})?$/;
export const PRICING_SUPPORT_THREE_DECIMALS_REGEX = /^(?:\d+|\d*\.\d{1,3})$/;
// EVES-3952: Site & Site Area Defects
// Author: Abhishek Bharti
// Date: 17/11/2025
export const POSITIVE_NUMBER_REGEX = /^[+]?([1-9]\d*(\.\d+)?|0\.\d+)$/;

// EVES-4468: Stricter Password Policy
//Author: Gervill Caintapan
//Date: 31/03/2026
export const PASSWORD_POLICY_REGEX = {
  MIN_LENGTH: /^.{14,16}$/, // 14 to 16 characters
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /[0-9]/,
  SPECIAL_CHAR: /[!@$#%&]/, // Specific list from requirements
};